export default class DeleteResultadoPersonalC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idResultado) {
    await this.#repository.delete(idPersonal, idResultado)
  }
}
